import React, { useState, useRef, useEffect } from "react";
import { CiCirclePlus } from "react-icons/ci";
import { FaRegFolderOpen, FaPaperclip } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./AddPanel.css";
import ToggleSwitch from '../Menu/ToggleSwitch'
import { selectIsWebSearch, setIsWebSearch } from "../ChatApp/chatSlice";
import { useDispatch, useSelector } from "react-redux";
import { IoEarth } from "react-icons/io5";
import { Tooltip } from "react-tooltip";




const AddPanel = ({ onAddFile }) => {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  const navigate = useNavigate();
  const isWebSearch = useSelector(selectIsWebSearch);
  const dispatch = useDispatch();

  // Включаем isWebSearch по умолчанию только для quick, quick_fin, quick_all
  const selectedSubOption = useSelector(state => state.chat.selectedSubOption);
  useEffect(() => {
    if (["quick", "quick_fin", "quick_all"].includes(selectedSubOption)) {
      if (!isWebSearch) dispatch(setIsWebSearch(true));
    } else {
      if (isWebSearch) dispatch(setIsWebSearch(false));
    }
    // eslint-disable-next-line
  }, [selectedSubOption]);

  // Переключение панели
  const togglePanel = () => setOpen((prev) => !prev);

  // Закрытие при клике вне
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleGoToStorage = () => {
    navigate("/storage");
    setOpen(false);
  };

  const handleAddFileClick = () => {
    if (onAddFile) onAddFile();
    setOpen(false);
  };
  const handleToggle = () => {
    dispatch(setIsWebSearch(!isWebSearch));
    setOpen(false)
  };

  return (
    <div className="add-panel-container" ref={panelRef}
    >
      <CiCirclePlus className="add-icon" onClick={togglePanel}
        data-tooltip-id="addpanel-tooltip"
        data-tooltip-content="Добавить файлы и многое другое"
        data-tooltip-place="top"
      />
      <div
        className={`search-indicator ${isWebSearch ? "active" : ""}`}
        onClick={handleToggle}
      >
        <IoEarth className="earth-icon" />
      </div>

      {open && (
        <div className="add-menu">
          <div className="add-option" onClick={handleAddFileClick}>
            <FaPaperclip className="option-icon" />
            <span>Добавить файлы</span>
          </div>
          <div className="add-option" onClick={handleToggle}>
            <IoEarth className="option-icon" />
            <span>Поиск в сети</span>
          </div>
          <div className="add-option" onClick={handleGoToStorage}>
            <FaRegFolderOpen className="option-icon" />
            <span>Перейти в хранилище</span>
          </div>
        </div>
      )}

      <Tooltip
        id="addpanel-tooltip"
        // place="top"
        style={{
          color: "#fff",              // text color
          fontSize: "14px",
          borderRadius: "8px",
          padding: "8px 12px",
          zIndex: 9999,
        }}

      />
    </div>
  );
};

export default AddPanel;
